import { render, staticRenderFns } from "./TestMessage.vue?vue&type=template&id=229c263c&"
import script from "./TestMessage.vue?vue&type=script&lang=js&"
export * from "./TestMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports